export var SortStatesEnum;
(function (SortStatesEnum) {
    SortStatesEnum["Ascending"] = "asc";
    SortStatesEnum["Descending"] = "desc";
    SortStatesEnum["Neutral"] = "neutral";
})(SortStatesEnum || (SortStatesEnum = {}));
export const SortStates = {
    [SortStatesEnum.Ascending]: {
        state: SortStatesEnum.Ascending,
        nextState: SortStatesEnum.Descending,
    },
    [SortStatesEnum.Descending]: {
        state: SortStatesEnum.Descending,
        nextState: SortStatesEnum.Neutral,
    },
    [SortStatesEnum.Neutral]: {
        state: SortStatesEnum.Neutral,
        nextState: SortStatesEnum.Ascending,
    },
};
